import { getFullName } from "shared/utils/get-full-name";
import { ReportRerunActivity } from "../types";
import { RoleTitles } from "views/settings-users/slices/users/constants";
import { getApplicantRole } from "utils/getApplicantRole";

export const ReportRerun = ({
  activity,
  reportName
}: {
  activity: ReportRerunActivity;
  reportName: string;
}) => {
  const author = activity.author?.name ?? activity.author?.email;
  const authorRole: string =
    RoleTitles[activity.author?.author_role || ""] ?? "";
  const applicant = activity.details.contact;

  return (
    <div>
      <p>
        <span className="font-bold">{reportName} was re-run</span>
        {author && ` by ${author} `}
        {author && authorRole && `(${authorRole})`}
      </p>
      <p className="text-sm text-content-400 mt-2">
        {`for ${getFullName({
          firstName: applicant.first_name,
          lastName: applicant.last_name,
          middleName: applicant.middle_name,
          short: true
        })}`}
        {applicant.role ? ` (${getApplicantRole(applicant.role)})` : null}
      </p>
    </div>
  );
};
